/**
 * Polyfills del browser que se cargan ANTES de main.ts.
 *
 * Definidos en angular.json → architect.build.options.polyfills.
 *
 * `global` lo necesitan algunas libs de Node bundleadas vía libs/shared.
 * `reflect-metadata` lo necesita class-transformer / class-validator para
 * los decoradores en los DTOs.
 */
(globalThis as unknown as { global: typeof globalThis }).global = globalThis;
import 'reflect-metadata';
